import React, {useState} from 'react';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import IconButton from '@material-ui/core/IconButton';
import UpdateIcon from '@material-ui/icons/Update';
import InputAdornment from '@material-ui/core/InputAdornment';
import CalendarIcon from '@material-ui/icons/CalendarTodaySharp';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {DatePicker, DatePickerProps} from '@material-ui/pickers';
import {makeStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../../../utils/ThemeUtils';

const useStyles = makeStyles(theme => ({
    root: {
        [theme.breakpoints.up('md')]: {
            width: theme.spacing(50)
        },

        '& input': {
            height: '41.1px'
        }
    },
    popoverPaper: {
        marginTop: theme.spacing(1),
        //@ts-ignore
        backgroundColor: theme.palette.background.overlays,
        width: '475px'
    },
    toolbarRoot: {
        backgroundColor: theme.palette.background.paper
    },
    updateIcon: {
        position: 'relative',
        zIndex: 999999,
        marginLeft: getDirectionStyles(theme.direction)(0, theme.spacing(1)),
        marginRight: getDirectionStyles(theme.direction)(theme.spacing(1), 0)
    },
    calendarIcon: {
        paddingLeft: getDirectionStyles(theme.direction)(theme.spacing(2), 0),
        paddingRight: getDirectionStyles(theme.direction)(0, theme.spacing(2))
    }
}));

export type SupportDataPickerProps = Omit<DatePickerProps, 'value'>;

const SupporterDatePicker: React.FC<SupportDataPickerProps> = ({
    onChange,
    minDate = new Date(2018),
    maxDate = new Date(),
    ...props
}) => {
    const styles = useStyles();
    const [selectedDate, setDate] = useState(moment());
    const [isPristine, setPrestine] = useState(true);

    const handleChange = (date: moment.Moment) => {
        try {
            if (
                date.isSame(selectedDate) ||
                !date.isSameOrAfter(minDate) ||
                !date.isSameOrBefore(maxDate)
            ) {
                return;
            }

            setDate(date);
            setPrestine(false);
        } catch (err) {
            console.error('Unable to update chart date');
        }
    };

    const handleUpdate = () => {
        setPrestine(true);
        onChange(selectedDate);
    };

    return (
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <DatePicker
                {...props}
                className={styles.root}
                minDate={minDate}
                maxDate={maxDate}
                value={selectedDate}
                onChange={handleChange}
                onClose={handleUpdate}
                openTo="year"
                variant="inline"
                inputVariant="outlined"
                orientation="landscape"
                views={['year', 'month']}
                maxDateMessage={''}
                minDateMessage={''}
                InputProps={{
                    startAdornment: (
                        <InputAdornment className={styles.calendarIcon} position="start">
                            <CalendarIcon />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <IconButton
                            style={{visibility: isPristine ? 'hidden' : 'visible'}}
                            className={styles.updateIcon}
                            aria-label="Update"
                            size="small"
                            onClick={handleUpdate}>
                            <UpdateIcon />
                        </IconButton>
                    )
                }}
                PopoverProps={{
                    classes: {
                        paper: styles.popoverPaper
                    }
                }}
            />
        </MuiPickersUtilsProvider>
    );
};

export default SupporterDatePicker;
